export default __webpack_public_path__ + "static/media/ar_2016_image.83002c21.png";